'use client';

import { FilterItem } from '../../atoms/filter-item';
import type { FilterGroupProps } from './filter-group.types';

export function FilterGroup({
  group,
  type,
  onClick,
  itemRenderer,
}: FilterGroupProps) {
  return (
    <div className="flex flex-col gap-8-8">
      {group.items.map((item) => (
        <FilterItem
          onClick={onClick}
          key={item.value}
          filter={{
            name: group.key,
            value: item.value,
            label: item.label,
          }}
          type={type}
          itemRenderer={itemRenderer}
        />
      ))}
    </div>
  );
}
